/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedRecord from './record.defs.js'
import * as EmbedImages from './images.defs.js'
import * as EmbedVideo from './video.defs.js'
import * as EmbedExternal from './external.defs.js'

const $nsid = 'app.bsky.embed.recordWithMedia'

export { $nsid }

type Main = {
  $type?: 'app.bsky.embed.recordWithMedia'
  record: EmbedRecord.Main
  media:
    | l.$Typed<EmbedImages.Main>
    | l.$Typed<EmbedVideo.Main>
    | l.$Typed<EmbedExternal.Main>
    | l.Unknown$TypedObject
}

export type { Main }

const main = l.typedObject<Main>(
  $nsid,
  'main',
  l.object({
    record: l.ref<EmbedRecord.Main>((() => EmbedRecord.main) as any),
    media: l.typedUnion(
      [
        l.typedRef<EmbedImages.Main>((() => EmbedImages.main) as any),
        l.typedRef<EmbedVideo.Main>((() => EmbedVideo.main) as any),
        l.typedRef<EmbedExternal.Main>((() => EmbedExternal.main) as any),
      ],
      false,
    ),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type View = {
  $type?: 'app.bsky.embed.recordWithMedia#view'
  record: EmbedRecord.View
  media:
    | l.$Typed<EmbedImages.View>
    | l.$Typed<EmbedVideo.View>
    | l.$Typed<EmbedExternal.View>
    | l.Unknown$TypedObject
}

export type { View }

const view = l.typedObject<View>(
  $nsid,
  'view',
  l.object({
    record: l.ref<EmbedRecord.View>((() => EmbedRecord.view) as any),
    media: l.typedUnion(
      [
        l.typedRef<EmbedImages.View>((() => EmbedImages.view) as any),
        l.typedRef<EmbedVideo.View>((() => EmbedVideo.view) as any),
        l.typedRef<EmbedExternal.View>((() => EmbedExternal.view) as any),
      ],
      false,
    ),
  }),
)

export { view }
